module.exports = __webpack_public_path__ + "img/16.dcce0b64.png";